import React from 'react';
import { motion } from 'framer-motion';
export function ClosingCTA() {
  const scrollToProducts = () => {
    document.getElementById('productos')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 bg-[#F5F0EB] relative overflow-hidden" data-id="element-22">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-[#C9A96E]/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-23" />
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-[#C9A96E]/10 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-24" />

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl mx-auto text-center" data-id="element-26">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-stone-800 mb-8 leading-tight" data-id="element-27">
            Hoy podés seguir igual… o empezar a generar ingresos desde tu casa
          </h2>

          <p className="text-lg text-stone-600 mb-10 max-w-2xl mx-auto" data-id="element-28">
            El momento perfecto no existe. El mejor momento para empezar a
            construir tu propio negocio es hoy.
          </p>

          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={scrollToProducts} className="bg-[#5B9A6F] hover:bg-[#4A8A5E] text-white px-10 py-5 rounded-full font-semibold text-lg transition-colors duration-300 shadow-xl shadow-[#5B9A6F]/30 hover:shadow-2xl hover:shadow-[#5B9A6F]/40" data-id="element-29">
            EMPEZAR AHORA
          </motion.button>
        </motion.div>
      </div>
    </section>;
}